"use client";

import * as React from "react";
import { CopyButton } from "@/components/ui/copy-button";
import { cn } from "@/utils/utils";

interface InstallCommandProps {
  command: string;
  className?: string;
}

export function InstallCommand({
  command,
  className,
}: InstallCommandProps) {
  return (
    <div className={cn("relative my-4", className)}>
      <div className="absolute right-2 top-2 z-10">
        <CopyButton text={command} />
      </div>
      <div className="rounded-lg border bg-muted p-4 pr-12">
        <code className="text-sm font-mono">{command}</code>
      </div>
    </div>
  );
}

